// extracted by mini-css-extract-plugin
export default {"root":"AvatarIcon_root__P7w9O","adaptive":"AvatarIcon_adaptive__kKeur"};